// API URL Configuration
export const API_BASE_URL = process.env.NEXT_PUBLIC_API_BASE_URL || "https://cookies-docker-service-611728388817.europe-north2.run.app";

// Helper to build API endpoints
export const apiEndpoint = (path: string) => `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;